

exports.__esModule = true;
exports.$ChoiceEligibility = undefined;

var _angular = require('angular');

var _squid = require('squid');

var _logger = require('xo-beaver/dist/logger');

var _auth = require('../auth');

var _checkout = require('../checkout');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Variants:
// control
// 5 - If any choice treatment, do 5 unless 5 is ineligible
// 6 - If any choice treatment, do 6 if 5 is ineligible and 6 is eligible

var checkPPCInstallments = function checkPPCInstallments(token, _ref) {
    var checkoutSessionModel = _ref.checkoutSessionModel,
        checkoutPayeeModel = _ref.checkoutPayeeModel,
        checkoutCartModel = _ref.checkoutCartModel,
        checkoutAppDataModel = _ref.checkoutAppDataModel;

    // Check for installments - has credit in wallet, has credit offer in checkout session, and has installment options
    if (checkoutSessionModel.fundingOptions.hasCredit() && checkoutSessionModel.creditOffer && (0, _squid.$feature)('creditInstallmentOffers')) {
        var installmentOptions = _checkout.$InstallmentOptionsModel.instance(token);
        return installmentOptions.save({
            cache: true, // Cache response for selectFi page or wherever needed
            data: {
                payee: checkoutPayeeModel,
                checkoutCart: checkoutCartModel,
                checkoutAppData: checkoutAppDataModel,
                isMemberCredit: true
            },
            success: function success(result) {
                var offers = result.installments && result.installments[0];
                var hasInstallments = offers && offers.installment_options && offers.installment_options.length;

                return hasInstallments;
            },
            contingencies: {
                DEFAULT: function DEFAULT(message) {
                    // Assume is eligible if contingency
                    _logger.$logger.info('installments_contingency', {
                        message: message
                    });
                    return false;
                }
            },
            error: function error(err) {
                _logger.$logger.info('installments_error', err);
                return false;
            }
        });
    } else {
        return _squid.$promise.resolve(false);
    }
};

// Main logic to decide choice eligibility
var decideEligibility = function decideEligibility(token, _ref2) {
    var authModel = _ref2.authModel,
        checkoutCartModel = _ref2.checkoutCartModel,
        checkoutSessionModel = _ref2.checkoutSessionModel,
        checkoutAppDataModel = _ref2.checkoutAppDataModel,
        checkoutPayeeModel = _ref2.checkoutPayeeModel;
    var plan = checkoutSessionModel.plan,
        fundingOptions = checkoutSessionModel.fundingOptions;

    var plans = checkoutSessionModel.get('fundingOptions.plans');

    // Reasons for a transaction to be ineligible:
    //  - Doesn't meet pxp
    //  - is MSB
    //  - is billing
    //  - is split balance
    //  - balance covers full transaction but does not have preferred set
    //  - has PAD
    //  - is second button
    //  - is not US
    //  - has currency conversion
    //  - is not a merchant account

    // Check to see if any plans include split balance
    var splitBalance = plans && plans.some(function (option) {
        return option.primaryFs && option.secondaryFIs;
    });
    var MSB = plan.hasFundingMethodType('INCENTIVE');
    var billing = checkoutCartModel.isBilling();
    var PAD = plans && plans.some(function (option) {
        return option.primaryFs && option.primaryFs.subtype === 'PAD';
    });
    var secondButton = checkoutAppDataModel.is_second_button_txn;
    var isUS = checkoutAppDataModel.merchant.merchant_country === 'US';
    var fullBalance = plans && plans.some(function (option) {
        return option.primaryFs && option.primaryFs.type === 'BALANCE';
    });
    var hasPreferred = fundingOptions.getPreferred();
    var isNotMerchantAccount = authModel.account_type !== 2;
    var isNotAndroidPay = !checkoutCartModel.isWalletTokenization();
    var isNotFbBaFlow = !_squid.$integration.getConfig('IS_MESSENGER_BA_INTEGRATION');

    var involvedCurrencies = {};
    if (checkoutCartModel.get('purchase.amounts.total.currency_code') && plans) {
        involvedCurrencies[checkoutCartModel.purchase.amounts.total.currency_code] = 1;
        plans.forEach(function (option) {
            involvedCurrencies[option.primaryFs.amount.currency_code] = 1;
        });
    }

    var singleCurrency = _lodash2['default'].size(involvedCurrencies) <= 1;

    var choiceVariantsName = 'xo_hermes_choice_variant_(?:preferred_newusers_)?treatment_(.*)';

    // Check the global preferred experiment and the choice variant.
    // User must pass the global preferred experiment to be eligible to see a variant
    // Forced pxp call in case logged in user is different
    return (0, _squid.$pxp)('xo_hermes_choice_variant', {}, choiceVariantsName, true).then(function (choiceVariant) {
        var _$config$choiceExperi = _squid.$config.choiceExperiment;
        _$config$choiceExperi = _$config$choiceExperi === undefined ? {} : _$config$choiceExperi;
        var _$config$choiceExperi2 = _$config$choiceExperi.ignored;
        _$config$choiceExperi2 = _$config$choiceExperi2 === undefined ? {} : _$config$choiceExperi2;
        var _$config$choiceExperi3 = _$config$choiceExperi2.multipleFi,
            multipleFiIgnored = _$config$choiceExperi3 === undefined ? [] : _$config$choiceExperi3,
            _$config$choiceExperi4 = _$config$choiceExperi2.selectFi,
            selectFiIgnored = _$config$choiceExperi4 === undefined ? [] : _$config$choiceExperi4;

        // Check transaction eligibility

        var eligibilityCriteria = {
            'pxpVariant': choiceVariant,
            'noMSB': !MSB,
            'noBilling': !billing,
            'noSplitBalance': !splitBalance,
            'balanceWithPreferred': !(fullBalance && !hasPreferred),
            'noPAD': !PAD,
            'noSecondButton': !secondButton,
            'isUS': isUS,
            'singleCurrency': singleCurrency,
            'noMerchant': isNotMerchantAccount,
            'noAndroidPay': isNotAndroidPay,
            'isNotFbBaFlow': isNotFbBaFlow
        };
        // First check to see if transaction is eligible for choice at all.
        // Base eligibility check follows the selectFi eligibility
        var choiceIneligibleReasons = Object.keys(eligibilityCriteria).filter(function (key) {
            return selectFiIgnored.indexOf(key) === -1 && !eligibilityCriteria[key];
        });
        var transactionEligible = choiceIneligibleReasons.length === 0;

        if (!transactionEligible) {
            _logger.$logger.info('choice_experiment_ineligible', {
                failed: choiceIneligibleReasons.join()
            });

            _logger.$logger.info('checkout_fpti', {
                'from': 'CHOICE_ELG_CHK',
                'to': 'process_choice_elg_chk',
                'eligibility_reason': 'pxp_control-' + choiceIneligibleReasons.join()
            });

            return 'control';
        }

        // If eligible for choice, check if transaction is eligible for multipleFi variant
        return checkPPCInstallments(token, {
            checkoutCartModel: checkoutCartModel,
            checkoutSessionModel: checkoutSessionModel,
            checkoutAppDataModel: checkoutAppDataModel,
            checkoutPayeeModel: checkoutPayeeModel
        }).then(function (hasPPCInstallments) {
            var multipleFiEligibility = (0, _angular.extend)({
                creditInstallments: !hasPPCInstallments // check if does not have credit installments
            }, eligibilityCriteria);
            var multipleFiIneligibleReasons = Object.keys(multipleFiEligibility).filter(function (criteria) {
                return multipleFiIgnored.indexOf(criteria) === -1 && !multipleFiEligibility[criteria];
            }).join();
            var multipleFiEligible = multipleFiIneligibleReasons.length === 0;

            if (!multipleFiEligible) {
                _logger.$logger.info('choice_experiment_var5_ineligible', {
                    failed: multipleFiIneligibleReasons
                });

                _logger.$logger.info('checkout_fpti', {
                    'from': 'CHOICE_ELG_CHK',
                    'to': 'process_choice_elg_chk',
                    'eligibility_reason': 'pxp_6-' + multipleFiIneligibleReasons
                });

                return '6';
            }

            _logger.$logger.info('choice_experiment_eligible', {
                variant: '5'
            });

            _logger.$logger.info('checkout_fpti', {
                'from': 'CHOICE_ELG_CHK',
                'to': 'process_choice_elg_chk',
                'eligibility_reason': 'pxp_treatment'
            });

            return '5';
        });
    });
};

var promiseControl = _squid.$promise.resolve('control');

var $ChoiceEligibility = exports.$ChoiceEligibility = _squid.$Model.extend('$ChoiceEligibility', {
    getVariant: function getVariant(token) {
        var _this = this;

        if (!(0, _squid.$feature)('choiceExperiment')) {
            return promiseControl;
        }

        var models = {};

        return (0, _squid.$populate)(models, {
            authModel: _auth.$AuthModel.instance(),
            checkoutCartModel: _checkout.$CheckoutCartModel.instance(token),
            checkoutPayeeModel: _checkout.$CheckoutPayeeModel.instance(token),
            checkoutSessionModel: _checkout.$CheckoutSessionModel.instance(token),
            checkoutAppDataModel: _checkout.$CheckoutAppDataModel.instance(token)
        }).then(function () {
            // If user logged in is the same, we don't need the pxp call so we can skip the decision making logic
            if (_this.variant && models.authModel.buyer_id === _this.buyerId) {
                return _this.variant;
            }

            _this.variant = decideEligibility(token, models);
            _this.buyerId = models.authModel.buyer_id;

            return _this.variant;
        });
    }
});

_angular.extend;

_squid.$Model;

_squid.$pxp;

_squid.$promise;

_squid.$populate;

_squid.$config;

_squid.$feature;

_squid.$integration;

_logger.$logger;

_auth.$AuthModel;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutPayeeModel;

_checkout.$CheckoutSessionModel;

_checkout.$CheckoutAppDataModel;

_checkout.$InstallmentOptionsModel;


//////////////////
// WEBPACK FOOTER
// ./components/xo-models/src/choice/index.js
// module id = ./components/xo-models/src/choice/index.js
// module chunks = 1